export const dateFormatter = (date) => date?.split("-").reverse().join(".");